import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
    domain: '',
    cluster: '',
    complexity: '',
    dok_level: '',
    kpi: '',
    zpd_tag: '',
    zpd_anchor: '',
    knowledge_type: '',
    group: '',
    student: '',
  },
  benchmark: null,
  benchmarkStudent: null,
  goalbankSelection: {},
  curriculumSelection: {}
}

export const benchmarksUI = createSlice({
  name: 'benchmarksUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setDomain: (state, { payload }) => {
      state.tableFilters.domain = payload
    },
    setCluster: (state, { payload }) => {
      state.tableFilters.cluster = payload
    },
    setComplexity: (state, { payload }) => {
      state.tableFilters.complexity = payload
    },
    setDokLevel: (state, { payload }) => {
      state.tableFilters.dok_level = payload
    },
    setKpi: (state, { payload }) => {
      state.tableFilters.kpi = payload
    },
    setZpdTag: (state, { payload }) => {
      state.tableFilters.zpd_tag = payload
    },
    setZpdAnchor: (state, { payload }) => {
      state.tableFilters.zpd_anchor = payload
    },
    setKnowledgeType: (state, { payload }) => {
      state.tableFilters.knowledge_type = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setBenchmark: (state, { payload }) => {
      state.benchmark = payload
    },
    setBenchmarkStudent: (state, { payload }) => {
      state.benchmarkStudent = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setSubject,
  setDomain,
  setCluster,
  setComplexity,
  setDokLevel,
  setKpi,
  setZpdTag,
  setZpdAnchor,
  setKnowledgeType,
  setGroup,
  setStudent,
  setBenchmark,
  setBenchmarkStudent,
  trackActiveFilters,
  clearAllFilters,
} = benchmarksUI.actions

export default benchmarksUI.reducer
